__turbopack_context__.v({
  "fieldset": "NJWsuG_fieldset",
  "form": "NJWsuG_form",
  "headline": "NJWsuG_headline",
  "placeholder": "NJWsuG_placeholder",
  "radio-group": "NJWsuG_radio-group",
  "section": "NJWsuG_section",
  "status-message": "NJWsuG_status-message",
  "status-message-error": "NJWsuG_status-message-error",
  "status-message-success": "NJWsuG_status-message-success",
});
